import Vue from 'vue'
import Vuex from 'vuex'

import { fetchStories, fetchItem } from './lib/api.js'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		stories: {},
		item: {}
	},
	mutations: {
		addStories(state, payload) {
			state.stories[payload.type] = payload.json
		},
		addItem(state, payload) {
			state.item[payload.id] = payload
		}
	},
	actions: {
		GET_STORIES: ({ dispatch, state }, type) => {
			if (state.stories[type]) {
				return Promise.resolve(state.stories[type])
			} else {
				return dispatch('GET_NEW_STORIES', type)
			}
		},
		GET_NEW_STORIES: ({ commit, state }, type) => {
			return fetchStories(type).then(json => {
				commit('addStories', {type, json})
				return state.stories[type]
			})
		},
		GET_ITEM: ({ commit, state }, id) => {

			if (state.item[id]) {
				return Promise.resolve(state.item[id])
			} else {
				return fetchItem(id).then(json => {
					commit('addItem', json)
					return json
				})
			}
		},
		GET_COMMENTS: ({ commit, state }, id) => {

			// Recursively get kids and its kids item
			function getKidsFrom(id) {
				const item = state.item[id]

				// Skip if there is no kids
				if (!item.kids) return

				Promise.all([
					item.kids.map(kid => {
						if (state.item[kid]) {
							return Promise.resolve(state.item[kid])
						} else {
							return fetchItem(kid).then(json => {
								commit('addItem', json)
								if (json.kids) getKidsFrom(json.id)
								return json
							})
						}
					})
				])
			}

			getKidsFrom(id)
		}
	},
	computed: {
		stories: state => state.stories
	},
	getters: {
		getItemById: state => id => state.item[id],
		getStoriesByType: state => type => state.stories[type]
	}
})
